import { render, staticRenderFns } from "./TroubleShootingComments.vue?vue&type=template&id=f187280a"
import script from "./TroubleShootingComments.vue?vue&type=script&lang=js"
export * from "./TroubleShootingComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports